import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export default ({ courseID }) => (
  <Button as={Link} to={`/${courseID}/allConversations`} primary>
    Search all sessions
  </Button>
);
